import gql from 'graphql-tag';

export const GET_USERS_QUERY = gql`
  query GetUsers($queries: UserQuery!) {
    getUsers(queries: $queries) {
      total
      data {
        _id
        firstName
        lastName
        phoneNumber
        class {
          name
        }
        serie {
          name
        }
        region {
          name
        }
        gender
        school {
          name
        }
        status
      }
    }
  }
`;

export const GET_USER_DETAIL_QUERY = gql`
  query GetUser($id: MOID!) {
    getUser(id: $id) {
      _id
      firstName
      lastName
      phoneNumber
      gender
      points
      school {
        name
      }
      region {
        name
      }
      class {
        name
      }
      serie {
        name
      }
      status
    }
  }
`;
